
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'LeftArrow',

  props: {
    mimeTypeSlag: String
  }
})
